import React from 'react'
import styles from './DesktopGrid.module.scss'

export default function DesktopGrid(
    props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
) {
    return <div {...props} className={styles.root} data-rows={2} />
}
